import { Component, Prop, Vue } from "vue-property-decorator";
import { Column } from "@/models/Column";
import { matGetApp } from "@quasar/extras/material-icons";
import { isIEorEdge } from "@/utils/isIEorEdge";
import { decodeHtml } from "@/utils/decodeHtml";
import VariantTableHeaderCell from "@/components/VariantsTable/VariantTableHeaderCell.vue";
import { translate } from "@/utils/translation";
import { bus } from "@/main";
import busEvents from "@/bus/busEvents";
import { DynamicFile } from "@/models/DownloadDocument/DynamicFile";
import { downloadFile } from "@/utils/download";

declare const window: any;
@Component({
  components: {
    VariantTableHeaderCell,
  }
})
export default class ProductVariants extends Vue {
  @Prop() private title!: number;

  @Prop() private type!: number;

  @Prop() private columns: Array<Column> | undefined;

  @Prop() private items: Array<any> | undefined;

  @Prop() private loading!: boolean;

  @Prop() private scrollEnable!: boolean;

  private matGetApp = "";

  private showTooltip = false;

  public created() {
    this.matGetApp = matGetApp;
  }

  public updated() {
    if(this.items === undefined)
      return;
    this.items.forEach((item: any) => {
      const keys = Object.keys(item);
      keys.forEach((key: string) => {
        if(typeof(item[key]) === 'string')
          item[key] = decodeHtml(item[key]);
      });
    });
  }

  private pagination = {
    page: 1,
    rowsPerPage: 0 // 0 means all rows
  };

  public downloadFile(data: any, row: any) {
    const fileData = this.mapFileToDynamicFile({...data, code: row.LNItemCode, callback: (filepath: string) => downloadFile(fileData.name, filepath)});
    if(data.file.version !== "use-live-pdf-api")
      return downloadFile(fileData.name, data.file.url);
    bus.$emit(busEvents.DOWNLOAD_DYNAMIC_DOCUMENT, fileData)
  }

  private mapFileToDynamicFile(data: any): DynamicFile {
    return {
      id: data.file.id,
      name: `${data.file.subtype}_${data.code}`,
      templateName: data.file.subtype,
      tags: {
        code: data.code
      },
      callback: data.callback
    } as DynamicFile
  }

  public get hasVariants(): boolean {
    return true;
  }

  public Translate(text: string): string {
    return translate(text);
  }

  private _isIEorEdge() {
    return isIEorEdge();
  }

  private hasNotes(fieldName: string, obj: any) {
    if(fieldName !== "CodeWeb")
      return false;
    if(obj && obj.ItemHasNotes) {
      return obj.ItemHasNotes === "True";
    }
  }
}
